<app-dialog-header title="New Resource" (closeClicked)="onCancelClick()">
</app-dialog-header>

<form (ngSubmit)="onOkClick()" [formGroup]="resourceForm">
  <mat-dialog-content>
    <div class="resource-form-container">
      <!-- Resource Name Field -->
      <mat-form-field appearance="fill" class="form-field">
        <mat-label>Name*</mat-label>
        <input formControlName="resourceFC" matInput required type="text" [attr.aria-label]="'Resource name'"
          placeholder="Enter resource name" />
        @if (resourceForm.controls['resourceFC'].invalid && resourceForm.controls['resourceFC'].touched) {
        <mat-error>Name is required</mat-error>
        }
      </mat-form-field>

      <!-- Team Field -->
      <mat-form-field appearance="fill" class="form-field">
        <mat-label>Team*</mat-label>
        <mat-select formControlName="teamFC" required [attr.aria-label]="'Resource team'">
          <mat-option>-- Select Team --</mat-option>
          @for (team of teams$ | async; track team.id) {
          <mat-option [value]="team.id">{{ team.name }}</mat-option>
          }
        </mat-select>
        @if (resourceForm.controls['teamFC'].invalid && resourceForm.controls['teamFC'].touched) {
        <mat-error>Team is required</mat-error>
        }
      </mat-form-field>

      <!-- Location Field -->
      <mat-form-field appearance="fill" class="form-field">
        <mat-label>Location*</mat-label>
        <input formControlName="locationFC" matInput required type="text" readonly
          [attr.aria-label]="'Resource location'" placeholder="Click search icon to select location" />
        @if (resourceForm.controls['locationFC'].invalid && resourceForm.controls['locationFC'].touched) {
        <mat-error>Location is required</mat-error>
        }
        <div matSuffix>
          <button mat-icon-button type="button" (click)="selectLocation()" aria-label="Select location">
            <mat-icon>search</mat-icon>
          </button>
        </div>
      </mat-form-field>

      <!-- Location Details (if selected) -->
      @if (selectedLocation) {
      <div class="location-details">
        <div class="location-info">
          <div>Postcode: {{ selectedLocation.postCode }}</div>
          <div>Coordinates: {{ selectedLocation.latitude }}, {{ selectedLocation.longitude }}</div>
        </div>
      </div>
      }
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-flat-button [disabled]="!resourceForm.valid" color="primary" type="submit"
      aria-label="Save new resource">Save</button>
  </mat-dialog-actions>
</form>